import React from "react";

const cell7 = (
  { clickFunction, layerColors, isolatedLayer, allLayerFocus },
  ref
) => (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 289.8 223.2"
    className={`cell-svg nav ${isolatedLayer && "isolated"} ${
      allLayerFocus && "all-focus"
    }`}
    onClick={clickFunction}
    ref={ref}
  >
    <g
      id="Color_5"
      className={`${isolatedLayer === 5 ? "fill-group focus" : "fill-group"}  ${
        allLayerFocus && "no-fill"
      }`}
    >
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M136.3,197.8c4.2-0.1,10.2,0.4,11.3-2.3c2.3-5.6,4.4-15.2-1.5-18.5c-5.8-3.3-1.1,9.6-3.6,12
		c-6.9,6.6-18,2.7-27.3,3.4c-19.4,1.5-38.9,1.3-58.4,0.1c-5.7-0.3-12.7-0.6-19.3-0.1c-11.1,0.9-22.8-1.8-33.8,1.5
		c-1.1,0.3,0.2,4.1,1.6,4.1C49,197.9,92.6,198.4,136.3,197.8z"
      />
    </g>
    <g
      id="Color_4"
      className={`${isolatedLayer === 3 ? "fill-group focus" : "fill-group"} `}
    >
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M59.6,192.7c0,0,0.1,0,0.1,0c0-0.1,0-0.2,0-0.3C59.7,192.5,59.6,192.6,59.6,192.7z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M59.7,192.3C59.7,192.3,59.7,192.3,59.7,192.3C59.7,192.4,59.7,192.4,59.7,192.3
		C59.7,192.4,59.7,192.4,59.7,192.3z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M16,12.7C16,12.7,16,12.7,16,12.7C16,12.7,16,12.7,16,12.7z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M15.7,12.5C15.7,12.5,15.7,12.5,15.7,12.5C15.7,12.5,15.7,12.5,15.7,12.5z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M197.3,16.8c-6.5,0.7-8.3-11.1-16.5-10.1c-0.1,0,0,1,0,1.6c6-0.3,10,5.5,11.6,9.8c0.6,1.6-3,5.1-4.3,4.4
		c-7.9-4.4-11.3-14.8-21.3-15.9c0.6-0.9,1.1-2.3,1.8-2.4c9.9-1.1,19.7-1.5,29.6-1.6V1.6c-13.9,0.2-27.9,0.4-41.8,0.3
		C107.6,1.6,58.7,2.2,9.9,3.6c-0.2,0.5-0.2,1-0.1,1.5c1.9-0.3,3.3-0.3,2.5,1.8c-1.1,2.8-5.9,5.7-5,9.9c0.9,4.2,4,9.7,9.4,8.6
		c2.9-0.6,5.9-0.4,7.9-3.4c3.1-4.8,4.5-11.5-0.9-14.8c0.6-0.9,1-2.2,1.8-2.4c4.6-1.1,9.3-2.1,13.8-0.8C40,4.3,41.4,5,41.2,6.1
		c0.1,0,0.1,0,0.2,0c0.5-0.9,1-2,1.5-1.9c21.1,1,41.9-1.5,62.9-0.3c-0.3,0.6-0.6,1.2-1,1.7l2.7,0.6c1.1-1,2.3-1.6,3.6-1.7
		c16.3-1.2,32.5-1.8,48.8-0.3c1.9,0.2,1.2,3.8,2.6,3.8c10.2-0.2,19,7.4,20.9,16.3c1.4,6.6-6.8,10.7-8.7,17.3
		c6.5-2.9,7.1-10.1,11.5-14.7c4.8-4.9,11-7.7,17.4-9.1c1.7-0.4,3.5-0.6,5.2-0.8c0-0.1,0-0.2,0-0.3C205.1,16.5,201.2,16.4,197.3,16.8
		z M16.7,24c-2-0.5-3.7-1.4-5.2-2.7c3-2.6,0.4-8.3,2.8-8.7c0.2,0,0.3-0.1,0.5-0.1c0,0,0,0,0,0c-0.2-0.7-0.2-1.6-0.4-1.9
		c-1.1-1.5,1.3-1.7,2.3-2.4c0.6,0.9,1.7,2.1,1.5,2.4c-0.8,1.1-1.4,1.8-1.8,2.2c0,0,0,0,0,0c0.8,0.8,0,2.9,0.4,4.1
		c0.2,0.7,0.8,1.1,1.7,0.9C18.9,21.9,18.6,24.5,16.7,24z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M30.6,141c-3.9,0.7-0.8,6.1-2.3,5.4c-11.7-5.5-10.3-20.9-6.4-31.6c-0.6,0-1.4-0.2-1.6,0.1c-2.6,4-2.5,8.5-3,13
		c-0.1,0.7-1.6,1.7-2.3,1.5c-6.7-2-6.5-9.1-5.3-14.6c-4.1,3-2.8,8.9-0.5,11.9c2.1,2.7,4,5.6,7,7.9c4.4,3.4,5.1,10,9.2,14.3
		c-3.7,2.3-9.9,5.5-14.5,5.9c0,0.1,0.1,0.3,0.1,0.4c2.7,0.2,5.8,0.7,8.4,0.7c-1.7,2.9-4.6,5.3-5.6,8.1c-0.4,1.1,1.8,0.5,2.9-0.2
		c5.4-3.6,5-16,12.9-11c0.1,0.1,0,0.3-0.2,0.7l1.8-0.8C30.1,149,29.8,145.1,30.6,141z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M138.9,197.8c-0.9,0-1.7,0-2.5,0c-43.7,0.6-87.3,0-131,0.3c-1.4,0-2.6-3.8-1.6-4.1c11-3.3,22.7-0.6,33.8-1.5
		c6.6-0.5,13.7-0.2,19.3,0.1c0.9,0.1,1.8,0.1,2.7,0.1c0-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1,0-0.1c-0.4,0-0.7,0-1.1,0
		c-0.9-0.1-1.7-1.3-2.6-1.4c-17.2-1-34.3,3.1-51.2-0.7c-4.4-1-2-8-1.2-12.6c6.8,3.8,18.2-5.2,20.1,5.2c0-1.8-0.4-4.4,1-4.8
		c2.3-0.8,4.6-1.2,7-1.4c0-0.1,0-0.1,0-0.2c-9.4,0-18.7-0.3-28.1-1.5c-0.9-3-1.5-6.3-1.6-9.4H1.7c0.1,18.6,0.1,37.1,1,56.1
		c9.6-0.9,19.1-1.3,28.5-1.4c-9.2-0.2-18.4-0.4-27.6-0.7c-2.2-8.2-2.6-20.8,8.7-20.1c2.6,0.2,5.4,0.5,7.8,0.4
		c36.8-1.2,74-0.6,110.9-0.8c2.6,0,5.2-0.3,7.9-0.6C138.9,198.3,138.9,198.1,138.9,197.8z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M288,68.1h-0.8c0.2,20.8,0.9,41.5-1.1,62.3c-0.2,1.9-3,5.7-5.2,8.6c-0.1,0.1-0.1,0.1-0.2,0.3l1.1,1.9
		c1.3-1.4,2.3-2.9,2.9-4.6c0.9,0.6,2.3,1.1,2.4,1.8c1.4,11.5-1,22.6-0.6,34c-12.5,2.4-25,2.5-37.5,2.2c0,0.3,0,0.6,0,0.9
		c2.1-0.1,4.7,0.6,7,0.9c9.9,1,19.5-2.8,29.6-0.3c0.8,0.2,1.6,1.5,1.6,2.4c0.2,3.2,0.3,6.5,0.3,9.7c0.3,0,0.7,0,1,0
		C288.7,148.2,288,108.1,288,68.1z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M138.9,197.8c0,0.2,0,0.5,0.1,0.7c0.3,0,0.5-0.1,0.8-0.1c0-0.2,0-0.4-0.1-0.6
		C139.4,197.8,139.1,197.8,138.9,197.8z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M32.7,176.6c0,0,0-0.1,0-0.1c-0.3,0-0.7,0-1,0c0,0.1,0,0.1,0,0.2C32,176.6,32.3,176.6,32.7,176.6z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M248.6,174.6v0.9c0.1,0,0.2,0,0.4,0c0,0,0,0,0,0c0-0.3,0-0.6,0-0.9C248.9,174.6,248.7,174.6,248.6,174.6z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M226.6,149c-0.1,0.1-0.3,0.2-0.5,0.3c-1.1,0.4-2.6-1.3-3.5-3c-0.1-0.3-1-0.1-1.6-0.1
		c2.2,6.6,1.5,13.8-3.5,19.2c2.7,1.2,3.2-1.6,4.1-2.8c2-2.7,1.8-6.5,3.4-9.1c0.7-1.1,1.8-2.2,2.8-3.3"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M14.7,12.5c0.2,0.8,0.5,1.3,1.6,0.3C16,12.5,15.5,12.4,14.7,12.5z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M276.1,21.3c0,2-1.8,3.7-1.4,5.1c1.3,5.1,6.2,7.8,9.5,12.1c0.2,0.2,2-0.3,2.1-0.7c1.5-11.1,1.1-22.2,0.1-33.1
		c-0.3-3.3-7.1-2-11.2-1.6c-0.7,0.1-1.7,1.6-1.5,2.3C275.3,10.8,276.1,16,276.1,21.3z"
      />
    </g>
    <g
      id="Color_3_00000133530181285079391710000006471536114897709737_"
      className={`${isolatedLayer === 1 ? "fill-group focus" : "fill-group"}  ${
        allLayerFocus && "no-fill"
      }`}
    >
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M40.3,7.3C51,13,59,22.8,59.5,35.3c0.8-0.6,2.7,1.2,2.4-0.8c-2-12.5-8.2-23.8-20.8-28c0.3-0.4,0.5-0.9,0.8-1.3
		H41C41.4,5.7,41.4,6.4,40.3,7.3z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M105,5.1c0,0.1-0.3,0.4-0.4,0.5c-3.4,4.4-10.3,3.8-14.7,7.8c-1.8,1.6-4.2,4.7-1.7,7c1.5-5.9,6.7-8.6,12.3-9.4
		c1.1-0.2,1.7,4.7,2.9,1.3c0.9-2.4,2.3-4.8,4-6.3c0.1,0,0.4-0.4,0.5-0.4"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M29.4,152.6c0.1,0,0.1,0.1,0.2,0.1c0.2,0.2-1.1,2-0.5,3.1c4.6,8.8,13.3,16.8,23.4,16.7
		c-10.2-3.6-19-10.9-21.6-20.7"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M18.6,156.8C18.6,156.8,18.6,156.9,18.6,156.8c-0.2,0.3-0.4,0.6-0.5,0.7c-1.6,2.2-3.6,4.1-4.4,6.3
		c-0.4,1.1,1.8,0.5,2.9-0.2c1.7-1.1,3-3.7,3.8-5.3c0-0.1,0.1-0.2,0.1-0.2"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M11,3.6c-3,0.1-6.1,0.2-9.1,0.3c-0.6,33.8,0,67.5-0.2,101.3c0,9.8,0.1,16.4-0.4,28.1C1,138,1.5,139,1.5,140.1
		c0.1,8.7,0.2,17.2,0.2,25.7H2c-0.1-3.2,0.4-6.2,1.8-8.5c1.2-1.9,3.5-2.3,6.2-2.3v-0.4c-2.7,0-4.7-1.2-5.2-4.3
		c-5.1-31.7-0.9-62.7-1.2-94.1c4.1,2.3,6.8,7.8,12.2,6.9c1.3-0.2,0.8-1.6,0.9-2.5C11.5,61.1,6,57.4,5,52.6c-3.3-16-2.1-31.3-0.6-47
		C6.1,6,8.7,5.2,10.4,5c0.1,0,0.2,0,0.3,0"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M249.6,174.6c-12.7-0.3-25.4-1-38.2,0c-1.8,0.1-4.2-1-6.1-1c-25.1,1.2-50.1,0.4-75.1,1c-23,0.6-46,0.6-69,1.1
		c-9,0.2-18.1,0.6-27.2,0.7v0.1c6.1-0.1,12.3,1.1,18.4,1.9c3.5,0.5,0.4,3.7,1.1,4c3.3,1.2,2.1-2.8,4.2-3.8c0.5-0.2,1.2,0.1,1.7-0.1
		c3.7-1.5,7.7-0.9,11.4-1.2c19-1.8,37.7,0.1,56.7-0.9c1.2-0.1,1.3,2.9,2.1,3.6c2.2,2,0.5-4.4,4-3.2c2.3,0.8,5.8-2.3,6.3,0.2
		c0.7,3.7,1.5,7.5,1.1,11.2c-0.4,2.7-4.3,2-6.6,2.3c-13.2,1.7-26,1.9-39.2,0.2c-2.8-0.4-1.3-2.6-0.9-4.2c-0.6,0-1.2,0-1.7,0
		c0.2,1.8-0.4,4-1.8,4c-10.9,0.1-21.5,2.6-32.3,2c-0.1,0-0.1,0-0.2,0v0.4c2.4,0.1,4.7,0.3,7.1,0.4c0,0,0.1,0,0.1,0
		c2.3,0.1,4.7,0.2,7,0.3c0.1,0,0.2,0,0.4,0c2.2,0.1,4.5,0.1,6.7,0.2c0.3,0,0.6,0,0.9,0c2.1,0,4.1,0,6.2,0c0.5,0,1,0,1.6,0
		c1.8,0,3.7,0,5.5-0.1c0.8,0,1.7,0,2.5-0.1c1.5,0,3.1-0.1,4.6-0.1c1.2,0,2.5-0.1,3.7-0.2c1.1-0.1,2.3-0.1,3.4-0.2
		c2.4-0.1,4.8-0.3,7.2-0.5c9.3-0.7,20.4,3.2,27.3-3.4c2.5-2.4-2.2-15.3,3.6-12c5.8,3.4,3.8,13,1.5,18.5c-0.1,0.2-0.2,0.4-0.3,0.5
		c0,0.1-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0-0.1,0.1-0.2,0.1
		c-0.2,0.1-0.5,0.2-0.7,0.3c0,0,0,0-0.1,0c-0.2,0.1-0.5,0.1-0.8,0.2c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0.1-0.6,0.1c-0.1,0-0.2,0-0.3,0
		c-0.2,0-0.5,0.1-0.7,0.1c-0.1,0-0.1,0-0.2,0c-0.3,0-0.7,0-1,0.1v0.5c3-0.2,5.9-0.3,8.9,0.3c0-7-0.5-13.9,0.3-20.9
		c0.1-0.7,1.5-1.7,2.3-1.5c7.4,1.5,14.1,0.5,21,0.1c25.1-1.4,50,0,75.1-0.8c0.3,0,0.6,0,0.8,0L249.6,174.6z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M93.8,193.5c0.8,0,1.7,0,2.5-0.1C95.5,193.4,94.7,193.4,93.8,193.5z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M101,193.3c1.2,0,2.5-0.1,3.7-0.2C103.4,193.1,102.2,193.2,101,193.3z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M145.3,197.3c-0.2,0.1-0.5,0.1-0.8,0.2C144.8,197.4,145,197.4,145.3,197.3z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M72.6,193.3c0.1,0,0.2,0,0.4,0C72.8,193.3,72.7,193.3,72.6,193.3z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M141.4,197.8L141.4,197.8c0.3,0,0.7,0,1-0.1C142.1,197.8,141.7,197.8,141.4,197.8z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M79.7,193.5c0.3,0,0.6,0,0.9,0C80.2,193.5,80,193.5,79.7,193.5z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M65.5,193C65.6,193,65.6,193,65.5,193C65.6,193,65.6,193,65.5,193z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M88.3,193.5c-0.5,0-1,0-1.6,0C87.3,193.5,87.8,193.5,88.3,193.5z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M143.3,197.7c-0.2,0-0.5,0.1-0.7,0.1C142.8,197.7,143.1,197.7,143.3,197.7z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M146,197c-0.2,0.1-0.5,0.2-0.7,0.3C145.6,197.2,145.8,197.1,146,197z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M144.2,197.5c-0.2,0-0.4,0.1-0.6,0.1C143.8,197.6,144,197.6,144.2,197.5z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M146.6,196.7c-0.1,0.1-0.3,0.2-0.4,0.2C146.3,196.8,146.5,196.8,146.6,196.7z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M108.1,192.9c2.4-0.1,4.8-0.3,7.2-0.5C112.9,192.6,110.5,192.8,108.1,192.9z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M147.1,196.2c-0.1,0.1-0.2,0.2-0.3,0.3C146.9,196.4,147,196.3,147.1,196.2z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M147.6,195.6c-0.1,0.2-0.2,0.4-0.3,0.5C147.4,195.9,147.5,195.8,147.6,195.6z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M289.1,2.1c-30.8-1.7-61.6-1-92.4-0.5v0.9c24.7-0.3,49.3,1.5,74,0.4c3.6,7.3,5,16.3,0.9,23.6
		c-3.8-3.1-9.6-4.2-13.8-1.5c-0.6,0.4-0.2,2.9,0.7,2.9c1.3-0.1,1.2-3.3,3.5-3.1c12.4,1.1,17.2,13.4,25.3,20.9
		c-0.3,11.4-0.2,22.9,0,34.3h0.7C288,54.1,288.2,28.1,289.1,2.1z M286.2,37.9c-0.1,0.4-1.9,1-2.1,0.7c-3.2-4.4-8.1-7.1-9.5-12.1
		c-0.4-1.4,1.4-3.2,1.4-5.1c0.1-5.3-0.8-10.6-2.4-15.8c-0.2-0.6,0.8-2.2,1.5-2.3c4.1-0.4,10.9-1.7,11.2,1.6
		C287.3,15.6,287.7,26.7,286.2,37.9z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M281.3,138.5c-0.1,0.1-0.2,0.3-0.3,0.4c-3,4-8.2,4.8-12.8,6.4c5.1,2,11.1-0.8,14.6-5.2c0,0,0-0.1,0.1-0.1"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M287.6,187.6c0.1,9.5-0.7,19-1,28.4c-37.4,5.4-75.1,2.1-112.7,2.9c-36.1,0.8-72.2,1.6-108.3,1.7
		c11.9,0.3,23.8,0.6,35.8,0.7c51.6,0.3,103-2.7,154.6-1.1c10.8,0.3,21.6,0,32.3-1.5c0.2-10.4,0.3-20.7,0.3-31.1H287.6z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M232.5,25.6c0.8,0.9,3.3,1.5,2.8,0.3c-2.3-5.6-8.8-7.2-14.2-10.1c-0.1-0.1,0.4-1.5,0.7-2.3
		c-2-0.2-1.7,2.1-2.7,2.3c-2.5,0.5-4.9,0.7-7.3,0.7c0,0.1,0,0.1,0,0.2C219.5,16.7,226.8,19.2,232.5,25.6z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M16.7,24c2,0.5,2.2-2.1,1.8-6.1c-0.8,0.2-1.4-0.2-1.7-0.9c-0.6-1.7,1.2-5.1-2.5-4.4c-2.4,0.5,0.2,6.1-2.8,8.7
		C13,22.6,14.7,23.4,16.7,24z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M40.3,61.5c0.6,0,1.5,0.1,1.6-0.1c1.6-6,4.4-11.1,8.5-15.3c5.1-5.2,13.1-6.8,20.6-6.5c0-0.6,0-1.2,0-1.7
		c-7,1.5-15.2,0.3-20.8,5.4C44.6,48.2,41.4,54.3,40.3,61.5z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M69.3,57.1c0,0.3,1,0.6,1.5,0.9c2-15.9,14.8-29.5,31.4-28.8c0-0.6,0-1.5,0-1.6C84.9,25.8,70.1,39.9,69.3,57.1z
		"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M121.2,140.7c-4.6-1.9-9.8,2.5-15.5,2.4c-2.1-0.1-2.2-4.7-4.1-2c-1.3,1.9,0.9,3,2.4,3.1
		c5.1,0.5,10.4-1.4,14.8-1.2c11,0.5,23.1-0.8,32.4-7.3C141.1,136.3,131.8,145.2,121.2,140.7z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M250.6,107.7c-6.2,5.1-14.9,5.8-21.8,1.8c-7.3,9.8-22.3,8.1-32.4,3.6c-1-0.4-2.3-0.1-3.4-0.1
		c8.7,7.6,20.7,5.3,31.3,3.1c1.9-0.4,3.5-3.9,5.2-3.4c7,2.1,14.1,1.3,20-1.8c3.5-1.9,8.7-7.2,6.4-11.8
		C253.4,101.5,253.4,105.4,250.6,107.7z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M227.4,150.7c2-2,4.1-4.1,4.1-7.1c-3.8,0.3-3.1,4.9-5.4,5.7c0,0-0.1,0-0.1,0"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M259.6,146.3c-3.2,2.7-5.4,6.4-9,8.4c-3.7,2.1-7.7,3.7-12.1,3.7c13.4,3.1,26.1-10.9,27.9-23.6
		C261.5,137,263.4,143.1,259.6,146.3z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M18.1,10.6c0.2-0.3-0.9-1.5-1.5-2.4c-1,0.7-3.4,0.9-2.3,2.4C14.9,11.4,14.1,16.3,18.1,10.6z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M32.4,185.4c0.7-0.2,1.2-1,1.8-1.6c-0.9,0-1.7,0-2.6,0C32.1,184.2,30.5,186,32.4,185.4z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M25.4,208.2c0-0.6-0.2-1.4,0.1-1.6c0.3-0.3,1.3-0.3,1.5,0C27.8,207.8,26.2,207.8,25.4,208.2z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M16.7,211.7c0-0.6-0.2-1.4,0.1-1.6c0.3-0.3,1.3-0.3,1.5,0C19,211.3,17.4,211.3,16.7,211.7z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M95.3,204.7c-0.2-0.8,0.2-1.4,0.9-1.7c0.8-0.4,1.3,0.1,0.8,0.8C96.6,204.3,95.9,204.4,95.3,204.7z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M116,187.2c0-0.3-1-0.8-1.5-0.8c-0.7,0.1-1.4,1.1-0.8,1.5C114.4,188.4,116.1,188.5,116,187.2z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M196.9,186.4c0-1.2,2-1.2,2,0C198.9,187.9,196.9,187,196.9,186.4z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M174.7,206.5c0-0.9-0.3-2,0.1-2.5c0.4-0.4,1.6-0.1,2.5-0.1C176.5,204.7,175.6,205.6,174.7,206.5z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M220.2,202c-0.7-0.1-1.4-1.1-0.8-1.5c0.7-0.4,2.3-0.5,2.3,0.7C221.7,201.5,220.7,202,220.2,202z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M238.5,196.8c-0.6,0-1.4,0.2-1.6-0.1c-0.6-0.6,0-1.1,0.8-0.7C238,196.2,238.2,196.6,238.5,196.8z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M233.4,183.6c-0.6-0.4,0.1-1.3,0.8-1.5c1.3-0.4,2.3,0.6,1.5,1.5C235.3,184,233.9,184,233.4,183.6z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M259.4,183.6c-1.8,0.7-0.3-1.2-0.8-1.6c0.6,0,1.2,0,1.7,0C260,182.6,259.8,183.4,259.4,183.6z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M275.2,182.9c0-0.9-0.3-1.9,0.1-2.5c0.2-0.3,1-0.1,1.6-0.1C276.6,181.1,278,182,275.2,182.9z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M266.4,195.9c-0.8,0.4-1.1-0.1-0.8-0.8c0.5-1.3,2-1.2,2.4-0.7C268.9,195.4,267.2,195.6,266.4,195.9z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M254.9,204.7c0,0.6-0.9,1.3-1.5,0.8c-0.3-0.3-0.3-1.3,0-1.5C254,203.4,254.9,204.1,254.9,204.7z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M227.9,210.9c0.6,1.1-0.4,2.1-1.5,1.5c-0.3-0.1-0.3-1.2,0-1.5C226.7,210.6,227.7,210.7,227.9,210.9z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M174.7,182.9c-0.3-0.6-0.6-1.2-0.9-1.7c0.6,0,1.4-0.2,1.6,0.1C176.1,181.8,175.3,182.5,174.7,182.9z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M159,185.4c-0.2,0.1-0.7,0.1-0.8,0c-0.4-0.9,0.2-1.9,0.9-2.5c0.4-0.3,1.4-0.3,1.5,0
		C161.3,184.2,159.9,184.8,159,185.4z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M129.4,213.4c-0.5-2,1.2-0.3,1.7-0.9c0.2,0.8-0.2,1.5-0.9,1.6C129.9,214.2,129.5,213.8,129.4,213.4z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M115.6,206.4c-0.8-1.7,1.1-0.2,1.5-0.8C117.3,207.4,115.7,206.6,115.6,206.4z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M77.8,212.6c-0.6,0-1.4,0.2-1.6-0.1c-0.6-0.6,0-1.1,0.8-0.7C77.3,211.9,77.5,212.3,77.8,212.6z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M49,209.9c0.6-0.6,1.2-1.2,1.7-1.7c0,0.6,0.2,1.4-0.1,1.6C50.3,210.1,49.6,209.9,49,209.9z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M56.1,204.5c-0.5-0.3,0.2-1.1,0.8-1.6C56.3,203.4,57.7,205.3,56.1,204.5z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M36.7,207.2c-0.3,0-0.8-0.5-0.7-0.7c0.1-0.7,1-1.3,1.5-0.8C38.1,206.2,37.4,207.1,36.7,207.2z"
      />
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M70.8,188c0.3,0,0.8-0.5,0.7-0.7c-0.1-0.7-1-1.3-1.5-0.8C69.5,187,70.2,187.9,70.8,188z"
      />
    </g>
    <g
      id="Color_2"
      className={`${isolatedLayer === 2 ? "fill-group focus" : "fill-group"}  ${
        allLayerFocus && "no-fill"
      }`}
    >
      <g>
        <path
          vectorEffect="non-scaling-stroke"
          className="cell-base"
          d="M140,176.9c-0.5-2.5-4,0.6-6.3-0.2c-3.5-1.2-1.9,5.2-4,3.2c-0.8-0.7-0.8-3.7-2.1-3.6
			c-19,1.1-37.7-0.9-56.7,0.9c-3.8,0.4-7.7-0.3-11.4,1.2c-0.5,0.2-1.2-0.1-1.7,0.1c-2.1,1-0.9,5-4.2,3.8c-0.7-0.3,2.3-3.5-1.1-4
			c-9.2-1.2-18.7-3.3-27.7-0.4c-1.4,0.5-1,3-1,4.8c-1.9-10.4-13.2-1.4-20.1-5.2c-0.8,4.6-3.2,11.6,1.2,12.6
			c16.9,3.8,34-0.4,51.2,0.7c0.9,0.1,1.7,1.3,2.6,1.4c10.8,0.6,21.4-1.8,32.3-2c1.3,0,2-2.2,1.8-4c0.6,0,1.2,0,1.7,0
			c-0.4,1.6-1.9,3.8,0.9,4.2c13.3,1.8,26,1.5,39.2-0.2c2.3-0.3,6.2,0.4,6.6-2.3C141.6,184.4,140.8,180.6,140,176.9z M32.4,185.4
			c-1.9,0.6-0.3-1.2-0.8-1.6c0.9,0,1.7,0,2.6,0C33.6,184.3,33.1,185.1,32.4,185.4z M70.8,188c-0.7-0.1-1.3-1-0.8-1.5
			c0.6-0.6,1.4,0.1,1.5,0.8C71.6,187.5,71.1,188,70.8,188z M113.7,187.9c-0.6-0.4,0.1-1.4,0.8-1.5c0.6-0.1,1.5,0.5,1.5,0.8
			C116.1,188.5,114.4,188.4,113.7,187.9z"
        />
        <path
          vectorEffect="non-scaling-stroke"
          className="cell-base"
          d="M287.2,178.5c-0.1-0.9-0.9-2.2-1.6-2.4c-10.1-2.5-19.7,1.3-29.6,0.3c-2.3-0.2-4.9-0.9-7-0.9
			c-25.1,0.8-50-0.6-75.1,0.8c-6.9,0.4-13.6,1.4-21-0.1c-0.8-0.2-2.2,0.8-2.3,1.5c-0.8,7-0.3,13.9-0.3,20.9
			c-6.4-1.3-12.8,0.5-19.2,0.5c-37,0.2-74.1-0.4-110.9,0.8c-2.5,0.1-5.2-0.3-7.8-0.4C1,198.7,1.4,211.3,3.6,219.6
			c56.8,2.1,113.5,0.6,170.3-0.6c37.6-0.8,75.2,2.5,112.7-2.9C287,203.5,288.1,191.1,287.2,178.5z M16.7,211.7
			c0-0.6-0.2-1.4,0.1-1.6c0.3-0.3,1.3-0.3,1.5,0C19,211.3,17.4,211.3,16.7,211.7z M25.4,208.2c0-0.6-0.2-1.4,0.1-1.6
			c0.3-0.3,1.3-0.3,1.5,0C27.8,207.8,26.2,207.8,25.4,208.2z M36.7,207.2c-0.3,0-0.8-0.5-0.7-0.7c0.1-0.7,1-1.3,1.5-0.8
			C38.1,206.2,37.4,207.1,36.7,207.2z M50.6,209.8c-0.3,0.3-1.1,0.1-1.6,0.1c0.6-0.6,1.2-1.2,1.7-1.7
			C50.7,208.8,50.9,209.5,50.6,209.8z M56.1,204.5c-0.5-0.3,0.2-1.1,0.8-1.6C56.3,203.4,57.7,205.3,56.1,204.5z M76.2,212.5
			c-0.6-0.6,0-1.1,0.8-0.7c0.4,0.2,0.6,0.5,0.9,0.8C77.2,212.6,76.5,212.8,76.2,212.5z M96.9,203.8c-0.4,0.5-1.1,0.6-1.7,0.9
			c-0.2-0.8,0.2-1.4,0.9-1.7C97,202.6,97.4,203.1,96.9,203.8z M115.6,206.4c-0.8-1.7,1.1-0.2,1.5-0.8
			C117.3,207.4,115.7,206.6,115.6,206.4z M130.2,214.2c-0.3,0-0.7-0.4-0.8-0.8c-0.5-2,1.2-0.3,1.7-0.9
			C131.3,213.4,130.9,214.1,130.2,214.2z M159,185.4c-0.2,0.1-0.7,0.1-0.8,0c-0.4-0.9,0.2-1.9,0.9-2.5c0.4-0.3,1.4-0.3,1.5,0
			C161.3,184.2,159.9,184.8,159,185.4z M175.5,181.2c0.6,0.6-0.2,1.2-0.8,1.6c-0.3-0.6-0.6-1.2-0.9-1.7
			C174.4,181.1,175.2,180.9,175.5,181.2z M174.7,206.5c0-0.9-0.3-2,0.1-2.5c0.4-0.4,1.6-0.1,2.5-0.1
			C176.5,204.7,175.6,205.6,174.7,206.5z M196.9,186.4c0-1.2,2-1.2,2,0C198.9,187.9,196.9,187,196.9,186.4z M220.2,202
			c-0.7-0.1-1.4-1.1-0.8-1.5c0.7-0.4,2.3-0.5,2.3,0.7C221.7,201.5,220.7,202,220.2,202z M226.3,212.4c-0.3-0.1-0.3-1.2,0-1.5
			c0.3-0.3,1.4-0.3,1.5,0C228.4,212,227.5,213,226.3,212.4z M235.7,183.6c-0.3,0.4-1.7,0.4-2.3,0c-0.6-0.4,0.1-1.3,0.8-1.5
			C235.4,181.7,236.4,182.7,235.7,183.6z M236.8,196.7c-0.6-0.6,0-1.1,0.8-0.7c0.4,0.2,0.6,0.5,0.9,0.8
			C237.9,196.8,237.1,197,236.8,196.7z M253.4,205.5c-0.3-0.3-0.3-1.3,0-1.5c0.6-0.5,1.5,0.2,1.5,0.8
			C254.9,205.3,254,206,253.4,205.5z M259.4,183.6c-1.8,0.7-0.3-1.2-0.8-1.6c0.6,0,1.2,0,1.7,0C260,182.6,259.8,183.4,259.4,183.6z
			 M266.4,195.9c-0.8,0.4-1.1-0.1-0.8-0.8c0.5-1.3,2-1.2,2.4-0.7C268.9,195.4,267.2,195.6,266.4,195.9z M275.2,182.9
			c0-0.9-0.3-1.9,0.1-2.5c0.2-0.3,1-0.1,1.6-0.1C276.6,181.1,278,182,275.2,182.9z"
        />
      </g>
    </g>
    <g
      id="Color_1_00000147218077088579662120000000934278642808290960_"
      className={`${isolatedLayer === 4 ? "fill-group focus" : "fill-group"}  ${
        allLayerFocus && "no-fill"
      }`}
    >
      <path
        vectorEffect="non-scaling-stroke"
        className="cell-base"
        d="M287.1,138.4c-0.1-0.7-1.5-1.2-2.4-1.8c-2.3,6.2-10.3,11.2-16.6,8.7c4.6-1.5,9.7-2.3,12.8-6.4
		c2.2-2.9,5.1-6.7,5.2-8.6c2.6-28.2,0.4-56.4,1.2-84.6c-8.1-7.5-13-19.7-25.3-20.9c-2.3-0.2-2.2,3-3.5,3.1c-0.9,0-1.3-2.4-0.7-2.9
		c4.2-2.8,10-1.7,13.8,1.5c4.1-7.3,2.7-16.2-0.9-23.6C236.7,4.5,203,0.4,168.7,4.1c-0.7,0.1-1.2,1.5-1.8,2.4
		c10,1.1,13.5,11.5,21.3,15.9c1.3,0.7,4.9-2.7,4.3-4.4c-1.6-4.3-5.6-10.1-11.6-9.8c0-0.6,0-1.5,0-1.6c8.1-1,10,10.8,16.5,10.1
		c7.3-0.7,14.3,0.5,21.9-1c0.9-0.2,0.7-2.6,2.7-2.3c-0.3,0.9-0.9,2.3-0.7,2.3c5.4,2.9,11.9,4.5,14.2,10.1c0.5,1.1-2,0.6-2.8-0.3
		c-7.8-8.7-18.6-10.1-28.8-7.9c-6.4,1.4-12.7,4.1-17.4,9.1c-4.4,4.5-5.1,11.8-11.5,14.7c1.9-6.6,10.1-10.7,8.7-17.3
		c-1.9-8.8-10.8-16.5-20.9-16.3c-1.5,0-0.7-3.6-2.6-3.8c-16.4-1.4-32.6-0.9-48.8,0.3c-3.4,0.3-6.1,4-7.6,8c-1.3,3.3-1.8-1.5-2.9-1.3
		c-5.6,0.8-10.8,3.5-12.3,9.4c-2.5-2.3,0-5.4,1.7-7c4.9-4.4,12.9-3.1,15.7-9.6c-21-1.2-41.8,1.3-62.9,0.3c-0.5,0-1.2,1.4-1.7,2.3
		c12.5,4.1,18.8,15.5,20.8,28c0.3,2-1.6,0.2-2.4,0.8C59,22.8,51,13,40.3,7.3c2.2-1.8,0-3-1-3.2C34.7,2.8,30.1,3.9,25.5,5
		c-0.8,0.2-1.2,1.5-1.8,2.4c5.4,3.3,4,10,0.9,14.8c-1.9,3-5,2.8-7.9,3.4c-5.3,1-8.5-4.4-9.4-8.6c-0.9-4.3,3.9-7.1,5-9.9
		C13.8,3,7.6,6.3,4.4,5.6c-1.5,15.7-2.7,31,0.6,47c1,4.7,6.5,8.5,11.7,8c-0.1,0.9,0.4,2.3-0.9,2.5c-5.4,0.9-8.1-4.6-12.2-6.9
		c0.3,31.5-3.9,62.4,1.2,94.1c1.4,8.7,14.4,2.3,20.6-1.6c-4.1-4.3-4.8-10.9-9.2-14.3c-3-2.3-4.9-5.2-7-7.9c-2.3-3-3.7-8.9,0.5-11.9
		c-1.2,5.5-1.4,12.6,5.3,14.6c0.7,0.2,2.2-0.8,2.3-1.5c0.5-4.5,0.4-9,3-13c0.2-0.3,1-0.1,1.6-0.1c-3.9,10.8-5.2,26.1,6.4,31.6
		c1.4,0.7-1.6-4.7,2.3-5.4c-3,15.2,8.2,26.6,21.8,31.4c-10.2,0.1-18.8-7.9-23.4-16.7c-0.6-1.1,0.8-2.9,0.5-3.1
		c-7.9-5.1-7.6,7.3-12.9,11c-1.1,0.8-3.3,1.4-2.9,0.2c1-2.8,3.9-5.1,5.6-8.1c-5.5,0-13.1-2.4-15.5,1.5C1,161.7,1.7,169,3.6,175
		c19.2,2.5,38.5,1.2,57.6,0.8c23-0.5,46-0.5,69-1.1c25-0.6,50,0.2,75.1-1c1.9-0.1,4.2,1.1,6.1,1c25.2-1.9,50.2,2.6,75.1-2.2
		C286.1,161,288.5,149.8,287.1,138.4z M50.3,46.2c-4.1,4.2-6.8,9.2-8.5,15.3c0,0.1-1,0.1-1.6,0.1c1.1-7.2,4.3-13.3,9.7-18.2
		c5.6-5.1,13.9-3.9,20.8-5.4c0,0.6,0,1.2,0,1.7C63.4,39.4,55.4,41,50.3,46.2z M70.8,58c-0.6-0.3-1.6-0.6-1.5-0.9
		c0.9-17.2,15.6-31.3,33-29.5c0.1,0,0,1,0,1.6C85.6,28.5,72.8,42.1,70.8,58z M118.8,143c-4.4-0.2-9.7,1.7-14.8,1.2
		c-1.5-0.1-3.8-1.2-2.4-3.1c1.9-2.7,2,1.9,4.1,2c5.7,0.1,10.9-4.3,15.5-2.4c10.6,4.4,19.9-4.4,30-5
		C141.9,142.2,129.8,143.5,118.8,143z M225,153.5c-1.6,2.6-1.4,6.4-3.4,9.1c-0.9,1.2-1.4,4-4.1,2.8c5-5.4,5.7-12.6,3.5-19.2
		c0.6,0,1.5-0.2,1.6,0.1c0.9,1.7,2.4,3.4,3.5,3c2.3-0.8,1.6-5.4,5.4-5.7C231.5,148,226.9,150.4,225,153.5z M229.6,112.6
		c-1.7-0.5-3.2,3-5.2,3.4c-10.7,2.2-22.7,4.5-31.3-3.1c1.2,0,2.4-0.3,3.4,0.1c10.1,4.5,25.1,6.2,32.4-3.6c6.8,3.9,15.5,3.3,21.8-1.8
		c2.8-2.3,2.7-6.2,5.3-8.6c2.3,4.5-2.8,9.9-6.4,11.8C243.7,114,236.6,114.7,229.6,112.6z M238.5,158.4c4.4,0,8.4-1.7,12.1-3.7
		c3.6-2,5.7-5.7,9-8.4c3.9-3.2,1.9-9.3,6.9-11.5C264.6,147.5,251.8,161.5,238.5,158.4z"
      />
    </g>
    <g id="Outline_-_match_color_and_line_weight_to_cell_1">
      <rect
        x="2"
        y="2.6"
        width="285.9"
        height="218"
        className="cell-nav-outline"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </svg>
);

export default React.forwardRef(cell7);
